import { ContentType, TypeCounts } from "@authory-packages/core";
import { V3COMBINED_AUDIO_TYPE, V3COMBINED_POST_TYPE, V3COMBINED_WEBSITE_EMAIL_TYPE } from "./getFormattedSourceTypes";

export const getSourceTypeCountsValues = (typeCounts: TypeCounts) => ({
    [ContentType.Article]: typeCounts.Article || 0,
    [ContentType.Video]: typeCounts.Video || 0,
    [V3COMBINED_POST_TYPE]:
        (typeCounts.TextPost || 0) +
        (typeCounts.ReplyPost || 0) +
        (typeCounts.Thread || 0) +
        (typeCounts.ImagePost || 0) +
        (typeCounts.VideoPost || 0),
    [V3COMBINED_WEBSITE_EMAIL_TYPE]: (typeCounts.Website || 0) + (typeCounts.Email || 0),
    [V3COMBINED_AUDIO_TYPE]: (typeCounts.PodcastItem || 0) + (typeCounts.Audio || 0),
    [ContentType.PdfFile]: typeCounts.PdfFile || 0,
    [ContentType.Image]: typeCounts.Image || 0,
    [ContentType.Book]: typeCounts.Book || 0
});
